<template>
  <div class="w-full sm:max-w-368 px-16 sm:px-0">
    <slot />
    <form class="flex flex-col mt-24 md:mb-4" @submit.prevent="setDuration">
      <h1 class="text-h3 mb-16">How long will your {{ selectedCategoryTitle }} Adventure last?</h1>
      <h2 class="text-body">Keep it simple—this is just an estimate</h2>
      <Card
        class="flex items-center flex-col mt-24 p-0 sm:p-24 sm:shadow-md sm:h-auto bg-transparent sm:bg-grey-background-subdued"
        :elevation="0"
      >
        <poppins-counter v-model="duration" :label="hourOrHours" :min="1" :max="12" class="text-h3 mb-24" />
        <StickyButton :value="isEdit ? 'Save' : 'Next'" />
      </Card>
    </form>
  </div>
</template>

<script lang="ts">
import PoppinsCounter from '../../../components/counter/PoppinsCounter.vue';
import Card from '../../../components/card/Card.vue';
import StickyButton from '../../../components/sticky_button/StickyButton.vue';

export default {
  name: 'Duration',
  components: { PoppinsCounter, Card, StickyButton },
  props: {
    adventureMetaData: {
      default: () => {},
      type: Object,
    },
    isEdit: {
      default: false,
      type: Boolean,
    },
  },
  data(): any {
    return {
      selectedCategoryTitle: this.$store.getters['adventures/adventureDraft'].adventureCategoryName,
      duration: this.$store.getters['adventures/adventureDraft'].duration / 60 || 2,
    };
  },
  computed: {
    hourOrHours() {
      return this.duration === 1 ? 'hour' : 'hours';
    },
  },
  methods: {
    async setDuration() {
      await this.$store.dispatch('adventures/updateStore', { duration: this.duration * 60 });
      this.$router.push({
        path: this.isEdit ? `/adventures/${this.$store.getters['adventures/adventureId']}/edit` : '/adventures/new/supplies',
      });
    },
  },
};
</script>
